// Event ticket purchases, as the profile lists them from users/{uid}/eventtickets/active/{cid}.
//
// Purchases reach that list from two writers with different shapes. The shop
// (eventtickets.js in falcon functions) writes `amount` in cents (price * quantity * 100) and a
// `name` of "<event>-<variation>". A purchase an admin adds by hand carries only `price` (euros,
// per ticket) and `variationId` - so reading `amount` and `name` alone printed "NaN€" and an empty
// name for it. These read both shapes the way the shop computes them.

const isNumber = (x) => typeof x === 'number' && !isNaN(x)

// The purchase's total in cents: its own `amount` when it has one, otherwise price * quantity.
// null when neither is there, so the caller can say nothing rather than print a made-up 0.
export const purchaseAmountCents = (p) => {
  if (!p) return null
  if (isNumber(p.amount)) return p.amount
  if (isNumber(p.price)) return Math.round(p.price * (isNumber(p.quantity) ? p.quantity : 1) * 100)
  return null
}

// The purchase's label: its own `name`, otherwise the ticket variation it was bought for.
export const purchaseName = (p, ticket) => {
  if (!p) return ''
  if (p.name) return p.name
  const variations = ticket && Array.isArray(ticket.variations) ? ticket.variations : []
  const variation = variations.find((v) => v && v.id === p.variationId)
  return (variation && variation.name) || ''
}
